export class Deferred<T> {
  private promiseReject: ((reason?: any) => void) | undefined
  private promiseResolve: ((value: PromiseLike<T> | T) => void) | undefined
  private promiseIsResolved = false
  public isPending = false

  public get promise(): Promise<T> {
    return new Promise((resolve, reject) => {
      this.promiseReject = reject
      this.promiseResolve = resolve
      this.promiseIsResolved = false
      this.isPending = false
    })
  }

  public get reject() {
    this.promiseIsResolved = false
    this.isPending = false
    return this.promiseReject
  }

  public get resolve() {
    this.promiseIsResolved = true
    this.isPending = false
    return this.promiseResolve
  }

  public get isResolved() {
    return this.promiseIsResolved
  }
}
